import { createSelector } from '@ngrx/store';
import { selectSearchResponse } from '@usf/ngrx-product';
import { SearchRequest, SearchResponse } from '@usf/product-types';

export const selectTotalFilter = (searchRequest: SearchRequest) =>
  createSelector(selectSearchResponse, (searchResponse: SearchResponse) => {
    let total = searchResponse?.selectedFacets?.selectedBeans?.length || 0;
    if (!!searchRequest?.sortOrder) {
      total += 1;
    }
    // RangeRefinementCount
    total += searchRequest?.rangeRefinements?.split('||').length || 0;
    return total;
  });

export const selectFilterRefinementMap = (searchRequest: SearchRequest) =>
  createSelector(
    selectSearchResponse,
    selectTotalFilter(searchRequest),
    (searchResponse: SearchResponse, total: number) => {
      let numberOfSelectedFilters: { [key: string]: number | string } = {};
      numberOfSelectedFilters.total = total;

      numberOfSelectedFilters.sortLabel = searchResponse?.sortOptions?.filter(
        so => so.navigationState === searchRequest?.sortOrder,
      )[0]?.label;

      const filterMap = searchResponse?.navigation?.reduce((map, nav) => {
        let count = 0;
        let selectedValues = '';
        if (nav.refinementType === 'RangeRefinementMenu') {
          count = searchRequest?.rangeRefinements?.split('||').length || 0;
          map[nav.displayName] = count;
        } else if (
          nav.refinementType === 'RefinementMenu' &&
          nav.refinements[0]?.multiSelect === true
        ) {
          count = nav.refinements?.filter(r => !!r.selected).length;
          selectedValues = nav.refinements?.filter(r => !!r.selected).reduce( (a,b) => a + ', ' + b.displayName, '');
          selectedValues = selectedValues.substring(2);
          if (count>1) {            
            map[nav.displayName] = count + '|' + selectedValues
          }
          else
          {
            map[nav.displayName] = selectedValues;
          }
          
        }
        else if (nav.refinementType === 'RefinementMenu' && nav.refinements[0]?.multiSelect === false) {
          map[nav.displayName] = nav.refinements?.find( r => !!r.selected)?.displayName;
        }
        return map;
      }, {});
      numberOfSelectedFilters = { ...numberOfSelectedFilters, ...filterMap };
      return numberOfSelectedFilters;
    },
  );
